(function () {
  function parseNum(val) {
    if (val == null || val === '') return NaN;
    return parseFloat(String(val).replace(',', '.'));
  }

  var MAX_BOXES_DEFAULT = 500;

  function initCalculator(root) {
    var coverage = parseNum(root.dataset.coverage);
    var boxPrice = parseInt(root.dataset.boxPrice, 10);
    var currency = root.dataset.currency || '£';
    var maxBoxes = parseInt(root.dataset.maxBoxes, 10) || MAX_BOXES_DEFAULT;
    var qtyInput = document.getElementById(root.dataset.qtyInput);
    if (!coverage || !boxPrice || !qtyInput) return;

    var m2Input = root.querySelector('[data-tt-m2]');
    var boxesInput = root.querySelector('[data-tt-boxes-input]');
    var wastageCheck = root.querySelector('[data-tt-wastage]');
    var boxesTextEl = root.querySelector('[data-tt-boxes-text]');
    var areaEl = root.querySelector('[data-tt-area]');
    var totalEl = root.querySelector('[data-tt-total]');
    var limitEl = root.querySelector('[data-tt-box-limit]');
    var form = root.closest('form');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    var syncing = false;

    qtyInput.setAttribute('max', String(maxBoxes));

    function setTotalDisplay(cents) {
      if (!totalEl) return;
      var amount = (cents / 100).toFixed(2);
      totalEl.innerHTML =
        '<span class="tt-pdp__total-currency">' + currency + '</span>' +
        '<span class="tt-pdp__total-amount">' + amount + '</span>';
    }

    function boxLabel(count) {
      return count + (count === 1 ? ' box' : ' boxes');
    }

    function showLimitMessage(show) {
      if (limitEl) limitEl.hidden = !show;
    }

    function clampBoxes(boxes) {
      if (boxes > maxBoxes) return maxBoxes;
      return boxes;
    }

    function setSummary(boxes, area, total, capped) {
      if (boxesTextEl) boxesTextEl.textContent = boxLabel(boxes);
      if (areaEl) areaEl.textContent = area;
      setTotalDisplay(total);
      qtyInput.value = String(boxes);
      showLimitMessage(!!capped);
      if (submitBtn) submitBtn.removeAttribute('aria-disabled');
    }

    function resetDefault() {
      if (m2Input) m2Input.value = '';
      if (boxesInput) boxesInput.value = '';
      setSummary(1, coverage.toFixed(2), boxPrice, false);
    }

    function updateFromM2() {
      if (syncing) return;
      syncing = true;

      var sqm = parseNum(m2Input.value);
      if (!sqm || sqm <= 0) {
        resetDefault();
        syncing = false;
        return;
      }

      var needed = sqm;
      if (wastageCheck && wastageCheck.checked) needed = sqm * 1.1;

      var rawBoxes = Math.ceil(needed / coverage);
      var capped = rawBoxes > maxBoxes;
      var boxes = clampBoxes(rawBoxes);
      var actualArea = (boxes * coverage).toFixed(2);

      if (boxesInput) boxesInput.value = String(boxes);
      if (capped && m2Input) m2Input.value = actualArea;
      setSummary(boxes, actualArea, boxes * boxPrice, capped);
      syncing = false;
    }

    function updateFromBoxes() {
      if (syncing) return;
      syncing = true;

      var rawBoxes = parseInt(String(boxesInput.value).replace(/[^\d]/g, ''), 10);
      if (!rawBoxes || rawBoxes <= 0) {
        resetDefault();
        syncing = false;
        return;
      }

      var capped = rawBoxes > maxBoxes;
      var boxes = clampBoxes(rawBoxes);
      var actualArea = (boxes * coverage).toFixed(2);

      if (boxesInput) boxesInput.value = String(boxes);
      if (m2Input) m2Input.value = actualArea;
      setSummary(boxes, actualArea, boxes * boxPrice, capped);
      syncing = false;
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        var qty = parseInt(qtyInput.value, 10);
        if (qty > maxBoxes) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showLimitMessage(true);
          if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
        }
      }, true);
    }

    if (m2Input) {
      m2Input.addEventListener('input', updateFromM2);
      m2Input.addEventListener('change', updateFromM2);
    }
    if (boxesInput) {
      boxesInput.addEventListener('input', updateFromBoxes);
      boxesInput.addEventListener('change', updateFromBoxes);
    }
    if (wastageCheck) {
      wastageCheck.addEventListener('change', function () {
        if (m2Input && m2Input.value.trim() !== '') updateFromM2();
      });
    }

    resetDefault();
  }

  function initQuantityCalculator(root) {
    var unitPrice = parseInt(root.dataset.unitPrice, 10);
    var currency = root.dataset.currency || '£';
    var qtyInput = document.getElementById(root.dataset.qtyInput);
    var qtyField = root.querySelector('[data-tt-qty-input]');
    var totalEl = root.querySelector('[data-tt-total]');
    if (!unitPrice || !qtyInput || !qtyField) return;

    function setTotalDisplay(cents) {
      if (!totalEl) return;
      var amount = (cents / 100).toFixed(2);
      totalEl.innerHTML =
        '<span class="tt-pdp__total-currency">' + currency + '</span>' +
        '<span class="tt-pdp__total-amount">' + amount + '</span>';
    }

    function updateQuantity() {
      var qty = parseInt(String(qtyField.value).replace(/[^\d]/g, ''), 10);
      if (!qty || qty < 1) qty = 1;
      qtyField.value = String(qty);
      qtyInput.value = String(qty);
      setTotalDisplay(qty * unitPrice);
    }

    qtyField.addEventListener('input', updateQuantity);
    qtyField.addEventListener('change', updateQuantity);
    updateQuantity();
  }

  function bindSwipe(el, onSwipe) {
    var startX = 0;
    var startY = 0;
    var tracking = false;
    var isHorizontal = false;
    var didSwipe = false;
    var swipeThreshold = 40;
    var lockRatio = 1.25;

    el.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
      isHorizontal = false;
      didSwipe = false;
    }, { passive: true });

    el.addEventListener('touchmove', function (event) {
      if (!tracking || event.touches.length !== 1) return;
      var dx = event.touches[0].clientX - startX;
      var dy = event.touches[0].clientY - startY;
      if (!isHorizontal) {
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * lockRatio) {
          isHorizontal = true;
        } else if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx) * lockRatio) {
          tracking = false;
        }
      }
      if (isHorizontal) event.preventDefault();
    }, { passive: false });

    el.addEventListener('touchend', function (event) {
      if (!tracking) return;
      tracking = false;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (isHorizontal && Math.abs(dx) >= swipeThreshold && Math.abs(dx) > Math.abs(dy) * lockRatio) {
        didSwipe = true;
        onSwipe(dx < 0 ? 1 : -1);
        window.setTimeout(function () { didSwipe = false; }, 400);
      }
    }, { passive: true });

    return function wasSwipe() {
      return didSwipe;
    };
  }

  function chevronSvg(dir) {
    var path = dir === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
    return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="3.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"/></svg>';
  }

  function initGallery(root) {
    var viewport = root.querySelector('[data-tt-gallery-viewport]');
    var track = root.querySelector('[data-tt-gallery-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tt-gallery-slide]'));
    var orbs = Array.prototype.slice.call(root.querySelectorAll('[data-tt-gallery-orb]'));
    var prevBtn = root.querySelector('[data-tt-gallery-prev]');
    var nextBtn = root.querySelector('[data-tt-gallery-next]');
    var status = root.querySelector('[data-tt-gallery-status]');
    var total = slides.length;
    if (!viewport || !track || !total) return;

    var current = 0;
    var lightbox = null;

    /* ---------- the box takes the shape of the image on show ---------- */

    function slideRatio(index) {
      var slide = slides[index];
      if (!slide) return 0;
      var img = slide.querySelector('img');
      if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
        return img.naturalWidth / img.naturalHeight;
      }
      var declared = parseFloat(slide.getAttribute('data-ratio'));
      return declared > 0 ? declared : 0;
    }

    function sizeViewport(animate) {
      var ratio = slideRatio(current);
      var width = viewport.clientWidth;
      if (!ratio || !width) return;
      var height = Math.round(width / ratio);
      if (!height) return;
      if (animate) {
        viewport.style.height = height + 'px';
        return;
      }
      // No easing on first paint or on a resize: jump straight to the right height.
      viewport.classList.add('is-sizing');
      viewport.style.height = height + 'px';
      void viewport.offsetHeight;
      viewport.classList.remove('is-sizing');
    }

    sizeViewport(false);

    // Re-measure once each image is really in, in case its ratio was not known up front.
    slides.forEach(function (slide, index) {
      var img = slide.querySelector('img');
      if (!img || img.complete) return;
      img.addEventListener('load', function () {
        if (index === current) sizeViewport(false);
      }, { once: true });
    });

    var resizeTimer = null;
    var lastWidth = viewport.clientWidth;
    window.addEventListener('resize', function () {
      if (viewport.clientWidth === lastWidth) return;
      lastWidth = viewport.clientWidth;
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        sizeViewport(false);
      }, 120);
    });

    function finePointer() {
      return window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)').matches;
    }

    function setIndex(index) {
      current = (index + total) % total;
      track.style.setProperty('--tt-pdp-index', String(current));
      orbs.forEach(function (orb, i) {
        var active = i === current;
        orb.classList.toggle('is-active', active);
        if (active) orb.setAttribute('aria-current', 'true');
        else orb.removeAttribute('aria-current');
      });
      if (status) status.textContent = 'Image ' + (current + 1) + ' of ' + total;
      sizeViewport(true);
      if (lightbox) {
        lightbox.track.style.setProperty('--tt-pdp-index', String(current));
        lightbox.orbs.forEach(function (orb, i) {
          orb.classList.toggle('is-active', i === current);
        });
      }
    }

    function go(delta) {
      if (total < 2) return;
      setIndex(current + delta);
    }

    var wasSwipe = bindSwipe(viewport, go);

    viewport.addEventListener('click', function (event) {
      if (!finePointer()) return;
      if (wasSwipe()) return;
      if (event.target.closest('[data-tt-gallery-prev], [data-tt-gallery-next], [data-tt-gallery-orb]')) return;
      openLightbox();
    });

    if (prevBtn) prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      go(-1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      go(1);
    });
    orbs.forEach(function (orb) {
      orb.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setIndex(parseInt(orb.getAttribute('data-index'), 10) || 0);
      });
    });

    function ensureLightbox() {
      if (lightbox) return lightbox;

      var dialog = document.createElement('dialog');
      dialog.className = 'tt-pdp-lightbox';
      dialog.setAttribute('aria-label', 'Product photos');

      var slidesHtml = slides.map(function (slide) {
        return '<div class="tt-pdp-lightbox__slide"><img src="' +
          slide.getAttribute('data-full-src') +
          '" alt="' +
          (slide.getAttribute('data-alt') || '').replace(/"/g, '&quot;') +
          '"></div>';
      }).join('');

      var orbsHtml = total > 1
        ? slides.map(function (_, i) {
          return '<button type="button" class="tt-pdp__gallery-orb' + (i === current ? ' is-active' : '') +
            '" data-tt-lightbox-orb data-index="' + i + '" aria-label="Image ' + (i + 1) + ' of ' + total + '"></button>';
        }).join('')
        : '';

      dialog.innerHTML =
        '<div class="tt-pdp-lightbox__inner">' +
          '<div class="tt-pdp-lightbox__top">' +
            '<button type="button" class="tt-pdp-lightbox__close" data-tt-lightbox-close aria-label="Close">' +
              '<svg viewBox="0 0 18 17" aria-hidden="true"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>' +
            '</button>' +
          '</div>' +
          (total > 1
            ? '<button type="button" class="tt-pdp-lightbox__nav tt-pdp-lightbox__nav--prev" data-tt-lightbox-prev aria-label="Previous image">' + chevronSvg('prev') + '</button>' +
              '<button type="button" class="tt-pdp-lightbox__nav tt-pdp-lightbox__nav--next" data-tt-lightbox-next aria-label="Next image">' + chevronSvg('next') + '</button>'
            : '') +
          '<div class="tt-pdp-lightbox__viewport" data-tt-lightbox-viewport>' +
            '<div class="tt-pdp-lightbox__track" data-tt-lightbox-track>' + slidesHtml + '</div>' +
          '</div>' +
          (total > 1 ? '<div class="tt-pdp-lightbox__orbs" data-tt-lightbox-orbs>' + orbsHtml + '</div>' : '') +
          '<div class="tt-pdp-lightbox__bottom">' +
            '<button type="button" class="tt-btn tt-btn--primary tt-pdp-lightbox__done" data-tt-lightbox-close>Close</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(dialog);

      var lbViewport = dialog.querySelector('[data-tt-lightbox-viewport]');
      var lbTrack = dialog.querySelector('[data-tt-lightbox-track]');
      var lbOrbs = Array.prototype.slice.call(dialog.querySelectorAll('[data-tt-lightbox-orb]'));
      var lbWasSwipe = bindSwipe(lbViewport, go);

      dialog.querySelectorAll('[data-tt-lightbox-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeLightbox(); });
      });
      var lbPrev = dialog.querySelector('[data-tt-lightbox-prev]');
      var lbNext = dialog.querySelector('[data-tt-lightbox-next]');
      if (lbPrev) lbPrev.addEventListener('click', function (event) {
        event.preventDefault();
        go(-1);
      });
      if (lbNext) lbNext.addEventListener('click', function (event) {
        event.preventDefault();
        go(1);
      });
      lbOrbs.forEach(function (orb) {
        orb.addEventListener('click', function () {
          setIndex(parseInt(orb.getAttribute('data-index'), 10) || 0);
        });
      });
      lbViewport.addEventListener('click', function (event) {
        if (lbWasSwipe()) return;
        if (event.target.closest('[data-tt-lightbox-prev], [data-tt-lightbox-next]')) return;
      });

      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') go(-1);
        if (event.key === 'ArrowRight') go(1);
      });
      dialog.addEventListener('close', function () {
        document.body.style.removeProperty('overflow');
      });

      lightbox = { dialog: dialog, track: lbTrack, orbs: lbOrbs };
      return lightbox;
    }

    function openLightbox() {
      var box = ensureLightbox();
      box.track.style.setProperty('--tt-pdp-index', String(current));
      box.orbs.forEach(function (orb, i) {
        orb.classList.toggle('is-active', i === current);
      });
      document.body.style.overflow = 'hidden';
      if (typeof box.dialog.showModal === 'function') {
        box.dialog.showModal();
      } else {
        box.dialog.setAttribute('open', '');
      }
    }

    function closeLightbox() {
      if (!lightbox) return;
      if (typeof lightbox.dialog.close === 'function' && lightbox.dialog.open) {
        lightbox.dialog.close();
      } else {
        lightbox.dialog.removeAttribute('open');
        document.body.style.removeProperty('overflow');
      }
    }
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-tt-accordion-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) {
          if (open) {
            panel.setAttribute('hidden', '');
          } else {
            panel.removeAttribute('hidden');
          }
        }
      });
    });
  }

  function initDelivery() {
    document.querySelectorAll('[data-tt-delivery]').forEach(function (el) {
      el.textContent = getDeliveryLabel();
    });
  }

  function getUkDateParts() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false,
      weekday: 'short'
    }).formatToParts(new Date());

    var map = {};
    parts.forEach(function (p) { map[p.type] = p.value; });
    return {
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10) - 1,
      day: parseInt(map.day, 10),
      hour: parseInt(map.hour, 10)
    };
  }

  function isWeekend(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }

  function nextWorkingDay(date) {
    var d = new Date(date.getTime());
    do {
      d.setDate(d.getDate() + 1);
    } while (isWeekend(d));
    return d;
  }

  function addWorkingDays(fromDate, days) {
    var d = new Date(fromDate.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }

  function getDeliveryLabel() {
    var uk = getUkDateParts();
    var now = new Date(uk.year, uk.month, uk.day);
    var afterCutoff = uk.hour >= 18;
    var leadDays = afterCutoff ? 2 : 1;
    var start = new Date(now.getTime());

    if (afterCutoff) {
      start = nextWorkingDay(start);
    } else if (isWeekend(start)) {
      start = nextWorkingDay(start);
    }

    var delivery = addWorkingDays(start, leadDays);
    var weekday = delivery.toLocaleDateString('en-GB', { weekday: 'short' });
    var dateStr = delivery.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
    return 'Delivery from ' + weekday + ', ' + dateStr;
  }

  function ttGetCartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function ttCartSections(cart) {
    return cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map(function (section) { return section.id; })
      : [];
  }

  function ttRefreshCartDrawer(cart) {
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var sourceDrawer = html.querySelector('#CartDrawer');
        var targetDrawer = document.getElementById('CartDrawer');
        var sourceBubble = html.querySelector('#shopify-section-cart-icon-bubble, #cart-icon-bubble');
        var targetBubble = document.querySelector('#shopify-section-cart-icon-bubble, #cart-icon-bubble');

        if (cart) cart.classList.remove('is-empty');
        if (targetDrawer && sourceDrawer) {
          targetDrawer.innerHTML = sourceDrawer.innerHTML;
        }
        if (targetBubble && sourceBubble) {
          targetBubble.innerHTML = sourceBubble.innerHTML;
        }
      });
  }

  // Samples are pre-provisioned "Sample" variants (kept in sync by Trident
  // Cockpit). Ordering one is a plain cart add — no app round-trip.
  // The limit comes from the Overseer (custom.tt_cart_rules.maxSamples); 5 if unset.
  function ttCartRules() {
    if (window.TridentCartKind && typeof window.TridentCartKind.rules === 'function') {
      return window.TridentCartKind.rules();
    }
    var raw = window.TT_CART_RULES || {};
    var max = parseInt(raw.maxSamples, 10);
    return { allowMixed: raw.allowMixed === true, maxSamples: max > 0 ? max : 5 };
  }

  function ttIsSampleCartItem(item) {
    var title = String(item.variant_title || '').toLowerCase();
    if (/\bsample\b/.test(title)) return true;
    var sku = String(item.sku || '').toLowerCase();
    return sku.indexOf('sample') >= 0;
  }

  function ttFetchCartState() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .catch(function () { return null; });
  }

  function ttAddSampleToCart(variantId, sections) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      }),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (response.ok) return data;
        throw new Error(
          (data && (data.description || data.message)) || 'Could not add to basket',
        );
      });
    });
  }

  function ttAddLineToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (response.ok) return data;
        throw new Error(
          (data && (data.description || data.message)) || 'Could not add to basket',
        );
      });
    });
  }

  function ttHandleTileAdd(btn) {
    var root = btn.closest('.tt-pdp__actions');
    var msgEl = root ? root.querySelector('[data-tt-atc-msg]') : null;
    var labelEl = btn.querySelector('.tt-pdp__atc-text');
    var defaultLabel = btn.dataset.ttAtcLabel || (labelEl ? labelEl.textContent : 'Add to basket');
    btn.dataset.ttAtcLabel = defaultLabel;

    function setButtonLabel(text) {
      if (labelEl) labelEl.textContent = text;
    }

    function showMessage(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.hidden = false;
      msgEl.classList.toggle('tt-pdp__sample-note--error', Boolean(isError));
    }

    var variantId = btn.dataset.variantId || '';
    var form = btn.dataset.formId ? document.getElementById(btn.dataset.formId) : null;
    var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;

    if (!variantId) {
      showMessage('This tile cannot be added right now. Please refresh the page.', true);
      return;
    }

    btn.disabled = true;
    if (msgEl) {
      msgEl.hidden = true;
      msgEl.textContent = '';
      msgEl.classList.remove('tt-pdp__sample-note--error');
    }

    var cart = ttGetCartElement();
    if (cart && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(btn);
    }

    var gate = window.TridentCartKind;
    var ready = gate && typeof gate.prepareTileAdd === 'function'
      ? gate.prepareTileAdd()
      : Promise.resolve(true);

    ready
      .then(function (allowed) {
        if (!allowed) return null;
        setButtonLabel('Adding…');
        return ttAddLineToCart(variantId, qty);
      })
      .then(function (added) {
        if (!added) return;
        showMessage('Added to your basket.', false);
        document.dispatchEvent(new CustomEvent('tt:cart:updated'));
        if (cart && typeof cart.open === 'function') {
          return ttRefreshCartDrawer(cart).then(function () {
            cart.open();
          });
        }
        window.location.href = '/cart';
      })
      .catch(function (error) {
        showMessage(error.message || 'Could not add to basket. Please try again.', true);
      })
      .finally(function () {
        btn.disabled = false;
        setButtonLabel(defaultLabel);
      });
  }

  function initAtc() {
    if (document.documentElement.dataset.ttAtcDelegated) return;
    document.documentElement.dataset.ttAtcDelegated = 'true';

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-tt-atc-btn]');
      if (!btn || btn.disabled) return;
      event.preventDefault();
      ttHandleTileAdd(btn);
    });
  }

  function ttHandleSampleClick(btn) {
    var root = btn.closest('[data-tt-sample]');
    var msgEl = root ? root.querySelector('[data-tt-sample-msg]') : null;
    var labelEl = btn.querySelector('.tt-pdp__sample-btn-label');
    var defaultLabel = btn.dataset.ttSampleLabel || (labelEl ? labelEl.textContent : btn.textContent);
    btn.dataset.ttSampleLabel = defaultLabel;

    function setButtonLabel(text) {
      if (labelEl) {
        labelEl.textContent = text;
        return;
      }
      btn.textContent = text;
    }

    function showMessage(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.hidden = false;
      msgEl.classList.toggle('tt-pdp__sample-note--error', Boolean(isError));
    }

    function showTilesBlock() {
      if (!msgEl) return;
      msgEl.classList.remove('tt-pdp__sample-note--error');
      msgEl.textContent = '';
      msgEl.appendChild(
        document.createTextNode(
          'Your basket has tiles in it. Samples are a separate order; check out those tiles first. ',
        ),
      );
      var viewBasket = document.createElement('button');
      viewBasket.type = 'button';
      viewBasket.className = 'tt-pdp__sample-note-link';
      viewBasket.textContent = 'View basket';
      viewBasket.addEventListener('click', function () {
        var drawer = ttGetCartElement();
        if (drawer && typeof drawer.open === 'function') drawer.open();
      });
      msgEl.appendChild(viewBasket);
      msgEl.hidden = false;
    }

    btn.disabled = true;
    if (msgEl) {
      msgEl.hidden = true;
      msgEl.textContent = '';
      msgEl.classList.remove('tt-pdp__sample-note--error');
    }

    var cart = ttGetCartElement();
    if (cart && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(btn);
    }

    var variantId = btn.dataset.variantId || '';
    if (!variantId) {
      showMessage(
        'Sample ordering is not set up for this tile yet. Please refresh the page or contact us.',
        true,
      );
      btn.disabled = false;
      setButtonLabel(defaultLabel);
      return;
    }

    ttFetchCartState()
      .then(function (cartState) {
        if (cartState && Array.isArray(cartState.items)) {
          var sampleCount = 0;
          var alreadyInCart = false;
          var hasTiles = false;
          var isSample = window.TridentCartKind
            ? window.TridentCartKind.isSampleItem
            : ttIsSampleCartItem;
          cartState.items.forEach(function (item) {
            if (!isSample(item)) {
              hasTiles = true;
              return;
            }
            sampleCount += item.quantity || 1;
            if (String(item.id) === String(variantId)) alreadyInCart = true;
          });
          var cartRules = ttCartRules();
          if (hasTiles && !cartRules.allowMixed) {
            showTilesBlock();
            return null;
          }
          if (alreadyInCart) {
            throw new Error('This sample is already in your basket.');
          }
          if (sampleCount >= cartRules.maxSamples) {
            throw new Error(
              'You can order up to ' + cartRules.maxSamples + ' samples per order.',
            );
          }
        }

        setButtonLabel('Adding sample…');
        var sections = ttCartSections(cart);
        return ttAddSampleToCart(variantId, sections);
      })
      .then(function (added) {
        if (!added) return;
        showMessage('Sample added to your basket.', false);
        document.dispatchEvent(new CustomEvent('tt:cart:updated'));
        if (cart && typeof cart.renderContents === 'function') {
          return ttRefreshCartDrawer(cart).then(function () {
            cart.open();
          });
        }
        window.location.href = '/cart';
      })
      .catch(function (error) {
        showMessage(error.message || 'Could not add sample. Please try again.', true);
      })
      .finally(function () {
        btn.disabled = false;
        setButtonLabel(defaultLabel);
      });
  }

  function initSample() {
    // Delegated listener: survives section re-renders, quick-view injection
    // and the theme editor without needing per-button re-initialisation.
    if (document.documentElement.dataset.ttSampleDelegated) return;
    document.documentElement.dataset.ttSampleDelegated = 'true';

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-tt-sample-btn]');
      if (!btn || btn.disabled) return;
      event.preventDefault();
      ttHandleSampleClick(btn);
    });
  }

  function initBackInStock() {
    document.querySelectorAll('[data-tt-back-in-stock-form]').forEach(function (form) {
      if (form.dataset.ttBackInStockInit) return;
      form.dataset.ttBackInStockInit = 'true';

      var root = form.closest('[data-tt-back-in-stock]');
      var msgEl = root ? root.querySelector('[data-tt-back-in-stock-msg]') : null;
      var btn = form.querySelector('button[type="submit"]');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        if (btn) btn.disabled = true;
        if (msgEl) {
          msgEl.hidden = true;
          msgEl.textContent = '';
          msgEl.classList.remove('tt-pdp__back-in-stock-msg--error');
        }

        fetch('/apps/trident-cockpit/back-in-stock', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok || !data.ok) throw new Error(data.error || 'Could not save your request');
              return data;
            });
          })
          .then(function (data) {
            if (msgEl) {
              msgEl.textContent = data.message || 'You are on the list — we will email you when this tile is back.';
              msgEl.hidden = false;
            }
            form.reset();
          })
          .catch(function (error) {
            if (msgEl) {
              msgEl.textContent = error.message || 'Something went wrong. Please try again.';
              msgEl.classList.add('tt-pdp__back-in-stock-msg--error');
              msgEl.hidden = false;
            }
          })
          .finally(function () {
            if (btn) btn.disabled = false;
          });
      });
    });
  }

  function initSimilarProducts() {
    document.querySelectorAll('[data-tt-similar-products]').forEach(function (root) {
      if (root.dataset.ttSimilarInit) return;
      root.dataset.ttSimilarInit = 'true';

      var grid = root.querySelector('[data-tt-similar-grid]');
      if (!grid) return;

      if (grid.children.length > 0) {
        root.hidden = false;
        root.classList.remove('tt-pdp__similar--pending');
        return;
      }

      var handle = root.getAttribute('data-product-handle') || '';
      if (!handle) return;

      fetch('/apps/trident-cockpit/similar-products?handle=' + encodeURIComponent(handle), {
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || !data.ok) throw new Error(data.error || 'Could not load similar products');
            return data;
          });
        })
        .then(function (data) {
          var products = data.products || [];
          if (!products.length) return;

          grid.innerHTML = products.slice(0, 4).map(renderSimilarCard).join('');
          root.hidden = false;
          root.classList.remove('tt-pdp__similar--pending');
          document.dispatchEvent(new CustomEvent('tt:tile-cards-updated'));
        })
        .catch(function () {
          root.hidden = true;
        });
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function badgeClass(name) {
    if (name === 'New in') return 'tt-badge tt-badge--new-in';
    if (name === 'Bestseller') return 'tt-badge tt-badge--bestseller';
    if (name === 'Clearance') return 'tt-badge tt-badge--clearance';
    if (name === 'Out of Stock') return 'tt-badge tt-badge--out-of-stock';
    if (name === 'On Sale') return 'tt-badge tt-badge--on-sale';
    return 'tt-badge';
  }

  function renderSimilarCard(product) {
    var badges = (product.badges || [])
      .filter(function (badge) {
        return badge !== 'On Sale' && badge !== 'Out of Stock';
      })
      .slice(0, 2)
      .map(function (badge) {
        return '<span class="' + badgeClass(badge) + '">' + escapeHtml(badge) + '</span>';
      })
      .join('');

    if (product.onSale) {
      badges += '<span class="tt-badge tt-badge--on-sale">On Sale</span>';
    }
    if (product.isOutOfStock) {
      badges += '<span class="tt-badge tt-badge--out-of-stock">Out of Stock</span>';
    }

    var sizeNote = product.multipleSizes
      ? '<p class="tt-tile-card__size tt-tile-card__size--multi">Multiple sizes</p>'
      : product.nominalSize
        ? '<p class="tt-tile-card__size">' + escapeHtml(product.nominalSize) + '</p>'
        : '';

    var priceHtml = '';
    if (product.priceValue) {
      priceHtml = '<p class="tt-tile-card__price' + (product.onSale ? ' tt-tile-card__price--sale' : '') + '">';
      if (product.compareValue) {
        priceHtml += '<s class="tt-tile-card__price-compare">' + escapeHtml(product.compareValue) + '</s>';
      }
      priceHtml += '<span class="tt-tile-card__price-value">' + escapeHtml(product.priceValue) + '</span>';
      priceHtml += '<span class="tt-tile-card__price-unit">' + escapeHtml(product.unit || '') + '</span></p>';
    }

    var imageHtml = product.imageUrl
      ? '<img class="tt-tile-card__img" src="' + escapeHtml(product.imageUrl) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" loading="lazy">'
      : '';

    return (
      '<article class="tt-tile-card tt-tile-card--compact">' +
        '<a href="' + escapeHtml(product.url) + '" class="tt-tile-card__stretched-link">' +
          '<span class="visually-hidden">' + escapeHtml(product.title) + '</span>' +
        '</a>' +
        '<div class="tt-tile-card__media">' +
          (badges ? '<div class="tt-badges tt-badges--card">' + badges + '</div>' : '') +
          '<div class="tt-tile-card__viewport"><div class="tt-tile-card__track">' +
            '<div class="tt-tile-card__slide">' + imageHtml + '</div>' +
          '</div></div>' +
        '</div>' +
        '<div class="tt-tile-card__body">' +
          '<h3 class="tt-tile-card__title">' + escapeHtml(product.title) + '</h3>' +
          sizeNote +
          priceHtml +
        '</div>' +
      '</article>'
    );
  }

  /* ---------- shape / size / design picker ---------- */

  function initShapeSelector(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tt-shape-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tt-shape-panel]'));
    if (!tabs.length || !panels.length) return;

    function swapIn(grid) {
      if (!grid) return;
      grid.classList.remove('is-swapping');
      // restart the fade
      void grid.offsetWidth;
      grid.classList.add('is-swapping');
    }

    function showSize(panel, size, animate) {
      var grids = Array.prototype.slice.call(panel.querySelectorAll('[data-tt-size-panel]'));
      var chips = Array.prototype.slice.call(panel.querySelectorAll('[data-tt-size-tab]'));
      grids.forEach(function (grid) {
        var on = grid.getAttribute('data-tt-size-panel') === size;
        grid.hidden = !on;
        if (on && animate) swapIn(grid);
      });
      chips.forEach(function (chip) {
        var on = chip.getAttribute('data-tt-size-tab') === size;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-selected', on ? 'true' : 'false');
        chip.tabIndex = on ? 0 : -1;
      });
    }

    function showShape(index, animate, moveFocus) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-tt-shape-tab') === String(index);
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on && moveFocus) tab.focus();
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-tt-shape-panel') === String(index);
        panel.hidden = !on;
        if (!on) return;
        // Keep whichever size was last open in this shape, so going back and forth is predictable.
        var grids = Array.prototype.slice.call(panel.querySelectorAll('[data-tt-size-panel]'));
        var open = grids.filter(function (grid) { return !grid.hidden; })[0] || grids[0];
        if (open && animate) swapIn(open);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        showShape(tab.getAttribute('data-tt-shape-tab'), true, false);
      });
    });

    // Left / right arrows move between shapes, as a tablist should.
    root.querySelectorAll('[role="tablist"]').forEach(function (list) {
      list.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        var items = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
        var at = items.indexOf(document.activeElement);
        if (at === -1) return;
        event.preventDefault();
        var next = items[(at + (event.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length];
        if (!next) return;
        if (next.hasAttribute('data-tt-shape-tab')) {
          showShape(next.getAttribute('data-tt-shape-tab'), true, true);
        } else {
          next.click();
          next.focus();
        }
      });
    });

    panels.forEach(function (panel) {
      panel.querySelectorAll('[data-tt-size-tab]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          showSize(panel, chip.getAttribute('data-tt-size-tab'), true);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-tt-calculator]').forEach(initCalculator);
    document.querySelectorAll('[data-tt-quantity-calculator]').forEach(initQuantityCalculator);
    document.querySelectorAll('[data-tt-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-tt-accordions]').forEach(initAccordions);
    document.querySelectorAll('[data-tt-shape-selector]').forEach(initShapeSelector);
    initDelivery();
    initBackInStock();
    initAtc();
    initSample();
    initSimilarProducts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
